goog.provide('el8.ptdata.prenatalFlowsheetVisitMeasurements');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.prenatalFlowsheetVisitMeasurement');
goog.require('el8.service.urls');

el8.ptdata.prenatalFlowsheetVisitMeasurements = (function() {

    var that = new el8_EntitySet({
        model: el8.ptdata.model.prenatalFlowsheetVisitMeasurement,
        items: [],
        observable: true,
        sortFn: function(a, b) {
            if (a.getDate().getTime() < b.getDate().getTime()) { return -1; }
            if (a.getDate().getTime() === b.getDate().getTime()) { return 0; }
            return 1;
        },
        saveFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            var mapped = item.asMap(true);
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('prenatalFlowsheetVisitMeasurements', [item]),
                data: JSON.stringify(mapped),
                async: (opts.async !== false), // defaults to true
                success: function(data) {
                    item.populate(data);
                    if (successCb) { successCb(item); }
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            el8.appservice.notifier.notify('Visit measurements being deleted...');
            $.el8_ajax({
                type: "DELETE", 
                url: el8.service.urls.get('prenatalFlowsheetVisitMeasurements', [item]),
                async: (opts.async !== false), // defaults to true
                success: function(data) {
                    if (successCb) { successCb(); }
                    that.remove(item, false);
                    el8.appservice.notifier.notify('Visit measurements deleted.');
                },
                error: errorCb
            });
        }
    });

    return that;
    
})();
